
















import Vue from 'vue';

export default Vue.extend({
  name: 'HoteltList',
  props: {
    hotel: Object,
  },
});
